import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import { useStaticQuery, graphql } from "gatsby"
import "./_index.scss"

import ModalRight from "§/src/components/atoms/content/modal-right"
import ContactForm from "./contact-form-ok"
import ContactIcon from '§/src/images/svg/contact-us-icon.svg'

const ContactModalFloatingCtaSalesforce = props => {
  const { t } = useTranslation()
  const modalid = 'floatingctamodal'
  const [submitted, setSubmitted] = useState(false)

  const formLinks = useStaticQuery(graphql`
    query FormLinks {
      globalFormLinks: wp {
        acfoptGlobalOptions {
          acfGlobal {
            privacyPolicyLink
            termsAndConditionsLink
          }
        }
      }
    }
  `)

  const settings = props.settings
  const ctaText = settings.ctaText || 'Contact us'
  const modalDescription = settings.modalDescription || 'Contact us'
  const modalTitle = props?.modalTitle || settings.modalTitle || t("Informazioni sul prodotto")
  const salesforceFormType = settings.salesforceFormType
  const pageUrl = props?.pageUrl

  const msgs = {
    fill: props.msg?.fill || modalDescription || t("Ti invitiamo a compilare il form sottostante per ricevere informazioni più dettagliate. Un tecnico Gefran ti contatterà molto presto."),
    submit: props.msg?.submit || t("Thanks for contacting us! We will get in touch with you shortly."),
  };

  return (
    <React.Fragment>
      <div className="pt-5"></div>
      <button className="cm-floating-cta btn btn-primary rounded-pill">
        <div
          className="btncontainer"
          data-bs-toggle="modal"
          data-bs-target={`#${modalid}`}>
        </div>
        <ContactIcon/>
        <span>{ctaText}</span>
      </button>

      <ModalRight modalid={modalid}>
        <h3 className="contact-modal__title">
          {modalTitle}
        </h3>
        <p className="mb-4">
          { submitted ? msgs.submit : msgs.fill }
        </p>
        <div
          className="d-flex flex-row align-items-center justify-content-end"
          style={{ marginBottom: "3.75rem" }}
        >
          {!submitted && (
            <span className="contact-modal__required-label">
              {t("*campi obbligatori")}
            </span>
          )}
        </div>
        {!submitted && (
          <ContactForm
            formType={salesforceFormType}
            pageTitle={props.pageTitle}
            formLinks={formLinks}
            onSuccess={() => setSubmitted(true)}
            pageUrl={pageUrl}
          />
        )}
      </ModalRight>
    </React.Fragment>
  )
}

export default ContactModalFloatingCtaSalesforce
